module.exports = __webpack_public_path__ + "img/paypal.4f7815bf.jpg";